module.exports = [{"value":"2020","text":"2563"},{"value":"2021","text":"2564"},{"value":"2022","text":"2565"},{"value":"2023","text":"2566"},{"value":"2024","text":"2567"},{"value":"2025","text":"2568"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/master/Date/yearsNumber.json
// module id = PFwH
// module chunks = 2